var _a;
import { GalleryLayout } from '../../types';
export var LayoutRadioValues;
(function (LayoutRadioValues) {
    LayoutRadioValues["GRID"] = "grid";
    LayoutRadioValues["MASONRY"] = "masonry";
})(LayoutRadioValues || (LayoutRadioValues = {}));
export var LayoutRadioValueMapping = (_a = {},
    _a[LayoutRadioValues.GRID] = GalleryLayout.GRID,
    _a[LayoutRadioValues.MASONRY] = GalleryLayout.MASONRY,
    _a);
//# sourceMappingURL=types.js.map